<ng-container *ngIf="entries$ | async as entries">
  <button *ngIf="entries.length > 0" class="btn {{ btnClass }}" (click)="exportCsv(entries)">
    <span class="material-symbols-outlined m-r-4"> download </span>

    {{ label | cxTranslate }}
  </button>
</ng-container>
